/** Prototype-aligned fixtures for UI tests and API fallback. */
export const MOCK_ADAPTATION_ITEMS = [
    {
        id: 1,
        enrollment_id: 1,
        employee_id: 11,
        full_name: "Касумов Александр Сергеевич",
        department: "Логистика",
        position: "Руководитель отдела логистики",
        date_hired: "2026-06-17",
        kind: "month_2",
        kind_label: "2 месяца",
        plan_date: "2026-08-24",
        fact_date: null,
        status: "collecting",
        status_label: "Сбор ответов",
        risk: "medium",
        risk_label: "Средний",
        outcome: "Требует внимания",
        progress: [
            { role: "employee", state: "waiting", label: "С" },
            { role: "manager", state: "done", label: "Р" },
            { role: "hr", state: "waiting", label: "H" },
        ],
        answers: [{ id: 1, role: "manager", payload: { mgr_keep: 3 }, submitted_at: "2026-08-22T10:00:00+04:00" }],
    },
    {
        id: 2,
        enrollment_id: 2,
        employee_id: 12,
        full_name: "Рубцов Дмитрий Витальевич",
        department: "Логистика",
        position: "Диспетчер автопарка",
        date_hired: "2026-06-24",
        kind: "month_2",
        kind_label: "2 месяца",
        plan_date: "2026-08-25",
        fact_date: null,
        status: "planned",
        status_label: "Запланирован",
        risk: "uncalculated",
        risk_label: "Не рассчитан",
        outcome: "Не рассчитан",
        progress: [
            { role: "employee", state: "waiting", label: "С" },
            { role: "manager", state: "waiting", label: "Р" },
            { role: "hr", state: "waiting", label: "H" },
        ],
        answers: [],
    },
    {
        id: 3,
        enrollment_id: 3,
        employee_id: 13,
        full_name: "Абайдуллин Артур Ильдарович",
        department: "Логистика",
        position: "Логист-экспедитор",
        date_hired: "2026-06-23",
        kind: "month_2",
        kind_label: "2 месяца",
        plan_date: "2026-08-23",
        fact_date: null,
        status: "overdue",
        status_label: "Просрочен",
        risk: "high",
        risk_label: "Высокий",
        outcome: "Критическая ситуация",
        progress: [
            { role: "employee", state: "waiting", label: "С" },
            { role: "manager", state: "done", label: "Р" },
            { role: "hr", state: "waiting", label: "H" },
        ],
        answers: [{ id: 2, role: "manager", payload: { mgr_keep: 1 }, submitted_at: "2026-08-23T11:00:00+04:00" }],
    },
    {
        id: 4,
        enrollment_id: 4,
        employee_id: 14,
        full_name: "Белогубов Андрей Витальевич",
        department: "Автоматизация",
        position: "Инженер-разработчик",
        date_hired: "2026-06-20",
        kind: "month_2",
        kind_label: "2 месяца",
        plan_date: "2026-08-20",
        fact_date: "2026-08-20",
        status: "completed",
        status_label: "Завершен",
        risk: "low",
        risk_label: "Низкий",
        outcome: "Стабильно",
        progress: [
            { role: "employee", state: "done", label: "С" },
            { role: "manager", state: "done", label: "Р" },
            { role: "hr", state: "done", label: "H" },
        ],
        answers: [
            { id: 3, role: "employee", payload: { m2_fit: 5, m2_team: 4, m2_stay: 5, m2_quality: 4 }, submitted_at: "2026-08-20T09:00:00+04:00" },
            { id: 4, role: "manager", payload: { mgr_keep: 5 }, submitted_at: "2026-08-20T12:00:00+04:00" },
            { id: 5, role: "hr", payload: { hr_recommend: 5, hr_notes: "Подтвердить испытательный срок." }, submitted_at: "2026-08-20T16:00:00+04:00" },
        ],
    },
    {
        id: 5,
        enrollment_id: 5,
        employee_id: 15,
        full_name: "Карпеева Валерия Олеговна",
        department: "Ресторан",
        position: "Менеджер ресторана",
        date_hired: "2026-08-18",
        kind: "week_1",
        kind_label: "1 неделя",
        plan_date: "2026-08-25",
        fact_date: null,
        status: "planned",
        status_label: "Запланирован",
        risk: "uncalculated",
        risk_label: "Не рассчитан",
        outcome: "Не рассчитан",
        progress: [
            { role: "employee", state: "waiting", label: "С" },
            { role: "manager", state: "muted", label: "Р" },
            { role: "hr", state: "waiting", label: "H" },
        ],
        answers: [],
    },
    {
        id: 6,
        enrollment_id: 6,
        employee_id: 16,
        full_name: "Сергеев Артем Валерьевич",
        department: "Автоматизация",
        position: "Стажер-разработчик Python",
        date_hired: "2026-07-21",
        kind: "month_1",
        kind_label: "1 месяц",
        plan_date: "2026-08-21",
        fact_date: "2026-08-22",
        status: "data_collected",
        status_label: "Данные собраны",
        risk: "medium",
        risk_label: "Средний",
        outcome: "Требует внимания",
        progress: [
            { role: "employee", state: "done", label: "С" },
            { role: "manager", state: "done", label: "Р" },
            { role: "hr", state: "waiting", label: "H" },
        ],
        answers: [
            { id: 6, role: "employee", payload: { m1_role: 3, m1_load: 3, m1_manager: 3, m1_growth: 3, m1_doubts: 3 }, submitted_at: "2026-08-22T10:00:00+04:00" },
            { id: 7, role: "manager", payload: { mgr_keep: 3 }, submitted_at: "2026-08-22T14:00:00+04:00" },
        ],
    },
    {
        id: 7,
        enrollment_id: 7,
        employee_id: 17,
        full_name: "Федотов Михаил Андреевич",
        department: "Автопарк",
        position: "Водитель-экспедитор",
        date_hired: "2026-06-24",
        kind: "control_2m",
        kind_label: "Контроль 2 месяца",
        plan_date: "2026-08-24",
        fact_date: "2026-08-24",
        status: "collecting",
        status_label: "Сбор ответов",
        risk: "uncalculated",
        risk_label: "Не рассчитан",
        outcome: "Без анкеты",
        progress: [
            { role: "employee", state: "done", label: "С" },
            { role: "manager", state: "muted", label: "Р" },
            { role: "hr", state: "waiting", label: "H" },
        ],
        answers: [{ id: 8, role: "employee", payload: { c2_ok: true, c2_need: "Нет" }, submitted_at: "2026-08-24T08:00:00+04:00" }],
    },
    {
        id: 8,
        enrollment_id: 8,
        employee_id: 18,
        full_name: "Молчанова Анна Игоревна",
        department: "Бухгалтерия",
        position: "Бухгалтер",
        date_hired: "2026-08-03",
        kind: "extra",
        kind_label: "Доп. точка",
        plan_date: "2026-08-26",
        fact_date: null,
        status: "planned",
        status_label: "Запланирован",
        risk: "medium",
        risk_label: "Средний",
        outcome: "Требует внимания",
        progress: [
            { role: "employee", state: "waiting", label: "С" },
            { role: "manager", state: "muted", label: "Р" },
            { role: "hr", state: "waiting", label: "H" },
        ],
        answers: [],
    },
];

export const MOCK_ADAPTATION_LIST = {
    period_label: "Этапы августа",
    year: 2026,
    month: 8,
    attention: { overdue: 1, this_week: 3, ready_hr: 1 },
    items: MOCK_ADAPTATION_ITEMS,
};

export const MOCK_HIRED_FOR_ADAPTATION = [
    { id: 19, full_name: "Новиков Павел", department: "Автоматизация", position: "Разработчик", date_hired: "2026-08-10" },
];
